/**
 * ═══════════════════════════════════════════════════════
 * MONTAGE · Bestellquelle
 * ═══════════════════════════════════════════════════════
 * Schreibt die Herkunft eines Besuchs als Warenkorb-Attribute. Shopify übernimmt
 * Warenkorb-Attribute in die Bestellung, sichtbar im Admin unter „Weitere Details“.
 * So steht an jeder Bestellung, über welche Anzeige sie kam, auch wenn Shopifys
 * eigene Conversion-Übersicht leer bleibt (kein Consent, anderes Gerät im Verlauf).
 *
 * Was geschrieben wird, nur wenn die Adresse UTM-Werte trägt:
 *   utm_source, utm_medium, utm_campaign, utm_content, utm_term, utm_id   letzter Kontakt,
 *       jede neue Anzeige überschreibt, fehlende Felder werden geleert
 *   einstieg        Pfad der Einstiegsseite, mit ?view= falls gesetzt
 *   einstieg_zeit   Zeitpunkt des letzten Kontakts, deutsche Zeit
 *   erstkontakt     Quelle / Kampagne / Anzeige · Zeit des ersten Kontakts,
 *                   wird nie überschrieben
 *
 * Die Schlüssel heißen bewusst utm_* ohne Unterstrich-Präfix. Attribute mit
 * führendem Unterstrich (etwa _ppuh_utm_* der Upsell-App) blendet der Shopify-Admin
 * aus, sie stehen zwar in der Bestellung, aber niemand sieht sie. Auswertungen,
 * die _ppuh_utm_* lesen, akzeptieren beide Formen.
 *
 * 🔴 Was es NICHT tut: einlegen, Formulare bauen, fetch gegen /cart/add.
 *    Nur /cart.js lesen und /cart/update.js mit `attributes`. Der Warenkorbinhalt
 *    und product_added_to_cart bleiben unberührt (EINGRIFFSREGELN.md § 2.2).
 *    Kein eigener Speicher (kein Cookie, kein localStorage): die Werte liegen im
 *    Warenkorb, den Shopify ohnehin führt.
 *
 * Ohne UTM-Werte in der Adresse passiert nichts, kein einziger Request.
 * Gleiche Werte wie schon im Warenkorb: ein Lesezugriff, kein Schreiben.
 * ═══════════════════════════════════════════════════════
 */
(() => {
  const FELDER = ['utm_source', 'utm_medium', 'utm_campaign', 'utm_content', 'utm_term', 'utm_id'];
  const params = new URLSearchParams(window.location.search);

  const neu = {};
  FELDER.forEach((feld) => {
    const wert = (params.get(feld) || '').trim();
    if (wert) neu[feld] = wert.slice(0, 200);
  });
  if (!neu.utm_source && !neu.utm_campaign) return;

  const root = (window.Shopify && window.Shopify.routes && window.Shopify.routes.root) || '/';
  const jetzt = new Date().toLocaleString('de-DE', {
    timeZone: 'Europe/Berlin',
    day: '2-digit',
    month: '2-digit',
    year: 'numeric',
    hour: '2-digit',
    minute: '2-digit',
  });
  const view = params.get('view');
  const einstieg = (window.location.pathname + (view ? `?view=${view}` : '')).slice(0, 200);

  fetch(`${root}cart.js`, { credentials: 'same-origin' })
    .then((antwort) => (antwort.ok ? antwort.json() : null))
    .then((warenkorb) => {
      if (!warenkorb) return;
      const alt = warenkorb.attributes || {};

      const attribute = {};
      FELDER.forEach((feld) => {
        const wert = neu[feld] || '';
        if ((alt[feld] || '') !== wert) attribute[feld] = wert;
      });
      if (Object.keys(attribute).length === 0) return;

      attribute.einstieg = einstieg;
      attribute.einstieg_zeit = jetzt;
      if (!alt.erstkontakt) {
        const kurz = [neu.utm_source, neu.utm_campaign, neu.utm_content].filter(Boolean).join(' / ');
        attribute.erstkontakt = `${kurz} · ${jetzt}`.slice(0, 250);
      }

      return fetch(`${root}cart/update.js`, {
        method: 'POST',
        credentials: 'same-origin',
        headers: { 'Content-Type': 'application/json', Accept: 'application/json' },
        body: JSON.stringify({ attributes: attribute }),
      });
    })
    .catch(() => {});
})();
